import React, { useState } from "react";
import { Button, Image, message, Modal, Select, Upload } from "antd";
import { EyeOutlined, UploadOutlined } from "@ant-design/icons";
import { useLevel1Onboarding } from "../../../../hooks/api/Tutors/Onboarding/useLevel1Onboarding";
import { qualifications } from "../qualifications";
import { useGetSubjectsQuery } from "../../../../hooks/api/Admin/Courses/useGetSubjectsQuery";
import axios from "axios";
import { getToken } from "../../../../utils/getToken";

const LevelOne = () => {
  const [payload, setPayload] = useState({
    professionalTitle: "",
    profilePicture: "",
    ids: [] as string[],
  });

  const [isModalVisible, setIsModalVisible] = useState(false);
  const { Option, OptGroup } = Select;

  const { mutateAsync } = useLevel1Onboarding();
  const { data } = useGetSubjectsQuery({ page: 1, limit: 100 });
  const token = getToken();

  // Handle change for area of expertise selection - directly stores IDs
  const handleExpertiseChange = (selectedIds: string[]) => {
    setPayload({
      ...payload,
      ids: selectedIds,
    });
  };

  // Handle professional title change
  const handleTitleChange = (value: string) => {
    setPayload({
      ...payload,
      professionalTitle: value,
    });
  };

  const handleUpload = async (selectedFile: File) => {
    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/misc/file-upload`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      message.success("File uploaded successfully!");
      setPayload((prev) => ({
        ...prev,
        profilePicture: response.data.data.fileUrl,
      }));
      console.log(response.data);
    } catch (error) {
      message.error("File upload failed!");
      console.error(error);
    }
  };

  const handleFileChange = async (e: any) => {
    const selectedFile = e.target.files?.[0] || null;
    if (selectedFile) {
      await handleUpload(selectedFile);
    }
  };

  const handleSubmit = () => {
    mutateAsync(payload);
  };

  return (
    <div>
      <div className="w-full mt-4">
        {payload?.profilePicture ? (
          <div className="flex flex-col items-center gap-2">
            <Image
              src={payload.profilePicture}
              alt="Profile"
              height={140}
              style={{ borderRadius: "8px" }}
            />
            <Button
              type="primary"
              icon={<EyeOutlined />}
              onClick={() => setIsModalVisible(true)}
              className="mt-3"
            >
              Preview Image
            </Button>
          </div>
        ) : (
          <Upload
            accept="image/*"
            showUploadList={false}
            beforeUpload={(file) => {
              handleFileChange({ target: { files: [file] } });
              return false; // Prevent automatic upload
            }}
          >
            <Button icon={<UploadOutlined />}>Upload Image</Button>
          </Upload>
        )}
        <Modal
          title="Image Preview"
          open={isModalVisible}
          footer={null}
          onCancel={() => setIsModalVisible(false)}
        >
          <img
            src={payload?.profilePicture}
            alt="avatar preview"
            style={{ width: "100%" }}
          />
        </Modal>

        <p className="mt-3">Educational Level</p>
        <Select
          onChange={handleTitleChange}
          value={payload.professionalTitle || undefined}
          placeholder="Select Option"
          className="w-full mt-2"
          size="large"
        >
          <Option value="" disabled>
            Select Option
          </Option>
          {qualifications?.map(({ degree, professional_title }) => (
            <Option value={degree} key={degree}>
              {professional_title}
            </Option>
          ))}
        </Select>
        <p className="mt-3">Select area of expertise</p>
        <Select
          mode="multiple"
          maxCount={10}
          onChange={handleExpertiseChange}
          value={payload.ids}
          placeholder="Select Option"
          className="w-full mt-2 capitalize"
          size="large"
        >
          {data?.data?.categories &&
            Object.keys(data.data.categories).map((category) => (
              <OptGroup key={category} label={category}>
                {data.data.categories[category].map((subject: any) => (
                  <Option
                    key={subject._id}
                    value={subject._id}
                    className="capitalize"
                  >
                    {subject.subject}
                  </Option>
                ))}
              </OptGroup>
            ))}
        </Select>
        <p className="mt-3 text-gray500">Select maximum of 10</p>
      </div>

      <button
        disabled={
          payload.ids.length === 0 ||
          !payload.professionalTitle ||
          !payload.profilePicture
        }
        className={`mt-8 w-full py-3 mb-4 bg-primary900 rounded-md text-white text-md float-right ${
          payload.ids.length === 0 ||
          !payload.professionalTitle ||
          !payload.profilePicture
            ? "opacity-50"
            : ""
        }`}
        onClick={handleSubmit}
      >
        Continue
      </button>
    </div>
  );
};

export default LevelOne;
